if (!customElements.get('rmc-grand-finals')) {
  customElements.define('rmc-grand-finals', class extends HTMLElement {
    connectedCallback() {
      this.records = [...this.querySelectorAll('[data-gf-record]')];
      this.buttons = [...this.querySelectorAll('[data-gf-select]')];
      this.panel = this.querySelector('[data-gf-panel]');
      if (!this.records.length || !this.panel) return;
      this.range = this.querySelector('[data-gf-range]');
      this.photo = this.querySelector('[data-gf-background]');
      const year = row => Number(row.querySelector('[data-gf-year]').textContent.trim());
      this.editions = this.records.filter(row => Number.isInteger(year(row)) && year(row) <= Number(this.dataset.currentYear)).sort((a, b) => year(a) - year(b));
      if (this.editions.length) {
        this.range.min = year(this.editions[0]);
        this.range.max = year(this.editions.at(-1));
        this.range.disabled = this.editions.length === 1;
        this.querySelector('[data-gf-start]').textContent = this.range.min;
        this.querySelector('[data-gf-end]').textContent = this.range.max;
        this.querySelector('[data-gf-scrubber]').hidden = false;
      }
      this.select = id => {
        const record = this.records.find(row => row.dataset.gfRecord === id);
        if (!record || this.selectedId === id) return;
        this.selectedId = id;
        if (this.loader) this.loader.onload = this.loader.onerror = null;
        for (const field of ['year', 'place', 'track', 'note', 'status']) this.panel.querySelector('[data-gf-' + field + ']').textContent = record.querySelector('[data-gf-' + field + ']').textContent;
        const source = record.querySelector('[data-gf-source]');
        const output = this.panel.querySelector('[data-gf-source]');
        output.hidden = !source;
        if (source) output.href = source.href;
        else output.removeAttribute('href');
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gfSelect === id)));
        this.range.value = year(record);
        this.range.setAttribute('aria-valuetext', ['year', 'place', 'status'].map(field => record.querySelector('[data-gf-' + field + ']').textContent.trim()).join(', '));
        this.range.style.setProperty('--gf-progress', (Number(this.range.max) === Number(this.range.min) ? 0 : (Number(this.range.value) - Number(this.range.min)) / (Number(this.range.max) - Number(this.range.min)) * 100) + '%');
        this.querySelector('[data-gf-output]').textContent = year(record);
        this.photo.hidden = true;
        this.photo.removeAttribute('src');
        const credit = this.querySelector('[data-gf-image-credit]');
        const state = this.querySelector('[data-gf-image-state]');
        credit.hidden = true;
        credit.removeAttribute('href');
        state.hidden = true;
        const url = this.panel.getBoundingClientRect().width * (window.devicePixelRatio || 1) <= 900 ? record.dataset.gfPhotoSmall || record.dataset.gfPhoto : record.dataset.gfPhoto;
        if (!url) {
          state.textContent = record.dataset.gfStatusCode === 'cancelled' ? this.dataset.cancelledImage : this.dataset.missingImage;
          state.hidden = false;
          return;
        }
        const loader = this.loader = new Image();
        loader.onload = () => {
          if (!this.isConnected || this.selectedId !== id) return;
          this.photo.style.objectPosition = record.dataset.gfFocus || '50% 50%';
          this.photo.src = url;
          this.photo.hidden = false;
          if (record.dataset.gfPhotoCaption && /^https?:\/\//i.test(record.dataset.gfPhotoSource)) {
            credit.href = record.dataset.gfPhotoSource;
            credit.querySelector('[data-gf-image-credit-text]').textContent = record.dataset.gfPhotoCaption;
            credit.hidden = false;
          }
        };
        loader.onerror = () => {
          if (!this.isConnected || this.selectedId !== id) return;
          state.textContent = this.dataset.failedImage;
          state.hidden = false;
        };
        loader.src = url;
      };
      this.onClick = event => {
        const button = event.target.closest('[data-gf-select]');
        if (button && this.contains(button)) this.select(button.dataset.gfSelect);
      };
      this.onInput = () => {
        const closest = this.editions.reduce((best, row) => Math.abs(year(row) - Number(this.range.value)) < Math.abs(year(best) - Number(this.range.value)) ? row : best, this.editions[0]);
        if (closest) {
          this.range.value = year(closest);
          this.select(closest.dataset.gfRecord);
        }
      };
      this.onBlock = event => {
        if (this.records.some(row => row.dataset.gfRecord === event.detail.blockId)) {
          this.select(event.detail.blockId);
          this.panel.scrollIntoView({block: 'nearest', behavior: 'instant'});
        }
      };
      this.addEventListener('click', this.onClick);
      this.range.addEventListener('input', this.onInput);
      document.addEventListener('shopify:block:select', this.onBlock);
      this.panel.hidden = false;
      this.selectedId = null;
      this.select(this.records[0].dataset.gfRecord);
      this.querySelector('[data-gf-years]').hidden = false;
      this.querySelector('details').open = false;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.range?.removeEventListener('input', this.onInput);
      document.removeEventListener('shopify:block:select', this.onBlock);
      if (this.loader) this.loader.onload = this.loader.onerror = null;
    }
  });
}
